// import React from "react";
//
// export default function ResetPass() {
//     return (
//         <div
//             className="offcanvas offcanvas-end popup-style-1 popup-reset-pass"
//             id="resetPass"
//         >
//             <div className="canvas-wrapper">
//                 <div className="canvas-header popup-header">
//                     <span className="title">Reset Your Password</span>
//                     <button
//                         className="icon-close icon-close-popup"
//                         data-bs-dismiss="offcanvas"
//                         aria-label="Close"
//                     />
//                 </div>
//                 <div className="canvas-body popup-inner">
//                     <form action="#" className="form-login">
//                         <div className="">
//                             <p className="text text-sm text-main-2">
//                                 Forgot your password? No worries! Enter your registered email to
//                                 receive a link and securely reset it in just a few steps.
//                             </p>
//                             <fieldset className="email mb_12">
//                                 <input type="email" placeholder="Enter Your Email*" />
//                             </fieldset>
//                         </div>
//                         <div className="bot">
//                             <div className="button-wrap">
//                                 <button
//                                     className="subscribe-button tf-btn animate-btn bg-dark-2 w-100"
//                                     type="submit"
//                                 >
//                                     Reset Password
//                                 </button>
//                                 <button
//                                     type="button"
//                                     data-bs-dismiss="offcanvas"
//                                     className="tf-btn btn-out-line-dark2 w-100"
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }
import React, {useEffect, useState} from "react";
import { authApi } from "../../api"; // ← BACKEND API'Nİ BURADAN AL
import toast from "react-hot-toast"; // ← TOAST İSTEĞE BAĞLI

export default function ResetPass() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        const el = document.getElementById("resetPass");
        if (!el) return;

        const onShow = () => setEmail(""); // Açıldığında kod temizle

        el.addEventListener("shown.bs.offcanvas", onShow);
        return () => el.removeEventListener("shown.bs.offcanvas", onShow);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const res = await authApi.requestPasswordReset({ email });
            toast.success("Code sent to your email");
            localStorage.setItem("resetEmail", email);


            // Offcanvas geçiş
            const offcanvas = window.bootstrap?.Offcanvas.getInstance(document.getElementById("resetPass"));
            offcanvas?.hide();
            setEmail("");

            setTimeout(() => {
                // const nextCanvas = new window.bootstrap?.Offcanvas(document.getElementById("resetPassCode"));

                const el = document.getElementById("resetPassCode");

                if (window.bootstrap && el) {
                    const nextCanvas = new window.bootstrap.Offcanvas(el);
                    nextCanvas.show();
                }

                //window.bootstrap.Offcanvas.getInstance(offcanvasEl) || new window.bootstrap.Offcanvas(offcanvasEl);
                // nextCanvas.show();
            }, 400);
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || "Failed to send reset code.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="offcanvas offcanvas-end popup-style-1 popup-reset-pass input-page" id="resetPass">
            <div className="canvas-wrapper">
                <div className="canvas-header popup-header">
                    <span className="title">Reset Your Password</span>
                    <button className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" />
                </div>
                <div className="canvas-body popup-inner">
                    <form onSubmit={handleSubmit} className="form-login">
                        <p className="text text-sm text-main-2">
                            Enter your email to receive a verification code.
                        </p>
                        <fieldset className="email mb_12">
                            <input
                                type="email"
                                placeholder="Enter Your Email*"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </fieldset>
                        {error && <div className="text-danger mt-2">{error}</div>}
                        <div className="button-wrap">
                            <button className="subscribe-button tf-btn animate-btn bg-dark-2 w-100" type="submit" disabled={loading}>
                                {loading ? "Sending..." : "Reset Password"}
                            </button>
                            <button type="button" data-bs-dismiss="offcanvas" className="tf-btn btn-out-line-dark2 w-100">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
